import { Button, Card, CardContent, CardHeader, IconButton, Menu, MenuItem, Pagination, Paper, Select, SelectChangeEvent, Stack, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useProgress } from "../../../contexts/ProgressContextProvider";
import { T_Page } from "../../../common/model/apiModel";
import apis from "../../../common/apis";
import dateformat from "dateformat";
import { T_Code } from "../../../common/model/codeModel";
import MoreVertIcon from "@mui/icons-material/MoreVert"
import React from "react";
import NeonModal from "../../../component/neon/NeonModal";
import { initialAlert, useAlert } from "../../../provider/AlertContextProvider";


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
  },
}));
    

export default function CodeList(){

    const navigator = useNavigate();
    const {alert,setAlert} = useAlert();

    const pagesize = 10;
    const [page,setPage] = useState(1);
    const [list,setList] =  useState<T_Code[] | null>(null);
    const {showProgress,setShowProgress} = useProgress();
    const [pageInfo,setPageInfo] = useState<T_Page>()
    
    const [selPcode,setSelPcode] = useState("all");
    const [selPcode1,setSelPcode1] = useState("gubun");
    const [selData,setSelData] = useState<T_Code>({pcode:"gubun"});
    const [isEdit,setIsEdit] = useState(false);

    const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
      };

    const getList = useCallback(async () => {
        try {
          setShowProgress(true);
          const result = await apis.code.codeList(
            {
              pCode:selPcode,
              page:Number(page),
              pagesize:pagesize,
            }
          );
          console.log("resut:",result)
            if(result.code=="1"){
            
                setList(result.data.list);
                setPageInfo(result.data);
                setShowProgress(false);
    
            }else{
                 
              setShowProgress(false);
            }
    
       
    
        } catch (err: any) {
          setShowProgress(false);
        }
      }, [page,selPcode]);

      useEffect(() => {
          getList();
      }, [page,selPcode]);
    
      

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
      const [menuRow, setMenuRow] = useState<number | null>(null)
      const open = Boolean(anchorEl);
      const handleClick = (e: React.MouseEvent<HTMLElement>, idx: number) => {
        setAnchorEl(e.currentTarget)
        setMenuRow(idx)
      }   
      const handleClose = () => {
          setAnchorEl(null);
          setMenuRow(null);
        }; 

      const [isModal,setIsModal] = useState(false);        
        const handleModalClose = () => {
          setIsModal(false);
        };
      
        const handleDel = (idx:any) => {
          console.log("item:",idx)
      
        }
        const handleEdit = (item:T_Code) => {
          setIsEdit(true);
          setSelData(item);
          setIsModal(true);
        }
        const handleInsert = () => {
          setIsEdit(false);
          setSelData({pcode:"gubun"});
          setIsModal(true);
        }
        const handleData= async()=>{
            if(!isEdit){
              console.log("request:",selData)
              const result = await apis.code.codeCreate(selData)
              console.log("resut:",result)
              if(result.code=="1"){
                setAlert({
                  msg: "등록되었습니다",
                  visible: true
                });
                getList();
              }else{
                setAlert({
                  msg: "등록중 오류가 발생하였습니다.",
                  visible: true
                });
              }
            }else{
              const result =await apis.code.codeEdit(selData)
              if(result.code=="1"){
                setAlert({
                  msg: "수정되었습니다",
                  visible: true
                });
                getList();
              }else{
                setAlert({
                  msg: "수정정중 오류가 발생하였습니다.",
                  visible: true
                });
              }
            }

            setIsModal(false);
         
        }
        const handleDataDel = (item:T_Code) => {

            setAlert({msg:item.name+"을 정말로 삭제 하시겠습까?",visible:true,buttonList:[
              {
                text:"예"
                ,onPress:async()=>{
                  const result = await apis.code.codeDelete(item)
                  console.log(result)
                  if(result.code=="1"){
                    setAlert(initialAlert)
                    setAlert({msg:"삭제가 완료되었습니다.",visible:true})
                    getList();
                  }else{
                    setAlert(initialAlert)
                    setAlert({msg:"삭제중 오류가 발생하였습니다.",visible:true})
                  }

                }
              }
            ]})


        }
      
    
    return(
      <>
      <Card sx={{width:'100%'}} >
        <CardHeader sx={{pr:5,pb:0,mb:0}} title="코드관리"    action={
                <Stack   direction="row"
                justifyContent="space-between"  // ← 여기만 바꿔주세요
                spacing={2}                     // 아이템 사이 약간의 간격
                sx={{ pt: 5, width: '100%' }}   // 전체 너비 확보
                >
          <Select
            value={selPcode}
            size="small"
            onChange={(event:SelectChangeEvent)=>{
              setSelPcode(event.target.value)
            }}
          >
          <MenuItem value="all">전체</MenuItem>
          <MenuItem value="gubun">구분</MenuItem>
          <MenuItem value="type">타입</MenuItem>
          </Select>
          <Button variant="outlined" onClick={()=>{
                                handleClose()
                                handleInsert();
          }}>
           등록
          </Button>
         </Stack>
        } />
       
      <CardContent>
      <TableContainer component={Paper}>
      <Table  aria-label="simple table">
        <TableHead>
          <TableRow >
          <StyledTableCell align="right"  sx={{width:180,textAlign:'center'}}>타입</StyledTableCell>
          <StyledTableCell align="right" sx={{width:'20%',textAlign:'center'}} >코드</StyledTableCell>
          <StyledTableCell align="right"  sx={{textAlign:'center'}}>이름</StyledTableCell>
          <StyledTableCell align="right"  sx={{textAlign:'center',width:100}}>비고</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        {list && list.map((item,idx) => (
            <TableRow
              key={idx}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              hover
            >
              <TableCell align="center">{item.pcode}</TableCell>
              <TableCell align="center">{item.code}</TableCell>
              <TableCell align="center">{item.name}</TableCell>
              <TableCell>
              <IconButton
                      aria-label="menu"
                      onClick={(e) => handleClick(e, idx)}
                    >
                      <MoreVertIcon />
                    </IconButton>
                    <Menu
                      anchorEl={anchorEl}
                      open={menuRow === idx}
                      onClose={handleClose}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                    >
                      <MenuItem
                        onClick={() => {
                          handleClose()
                         handleEdit(item);
                        }}
                      >
                        수정
                      </MenuItem>
                      <MenuItem
                        onClick={async() => {
                          handleClose()
                          handleDataDel(item)
                        }}
                      >
                        삭제
                      </MenuItem>
                    </Menu>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
        <Stack   direction="row"
          justifyContent="flex-end"
          alignItems="center" sx={{pt:5,justifyContent:'center',alignContent:'center',justifyItems:'center',alignItems:'ceter'}}>
        <Pagination count={pageInfo?.pages} showFirstButton showLastButton boundaryCount={2} onChange={handleChange}/>
        </Stack>
        
          <NeonModal
                  open={isModal}
                  onClose={handleModalClose}
                  title={ '코드 ' + (isEdit ? '수정' : '등록') }
                  btnList={[
                        {
                          text:"예"
                          ,variant:'contained'
                          ,onPress:()=>{
                            handleData();
                          }
                        },
                        {
                          text:"아니오"
                          ,onPress:()=>{
                            handleModalClose();
                          }
                        }
        
                  ]}
                  content={  <Table>
                    <TableBody>
                      <TableRow>
                      <TableCell>타입</TableCell>
                      <TableCell>
                      <Select
                        value={selData.pcode}
                        readOnly={isEdit?true:false}
                        size="small"
                        onChange={(event:SelectChangeEvent)=>{
//                          setSelPcode1(event.target.value)
                          setSelData({...selData,pcode:event.target.value})
                        }}
                      >
                      <MenuItem value="gubun">구분</MenuItem>
                      <MenuItem value="type">타입</MenuItem>
                      </Select>
                      </TableCell>
                      </TableRow>
                      <TableRow>
                      <TableCell>코드</TableCell>
                      <TableCell>
                        <TextField fullWidth size="small"  value={selData?.code} onChange={(event:any)=>{
                                  setSelData({...selData,code:event.target.value})
                        }}/>
                      </TableCell>
                      </TableRow>
                      <TableRow>
                      <TableCell>이름</TableCell>
                      <TableCell>
                        <TextField fullWidth size="small" rows={3} multiline value={selData?.name} onChange={(event:any)=>{
                                  setSelData({...selData,name:event.target.value})
                        }} />
                      </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>}
                />
        
        </CardContent>

      </Card>
      </>
    )
}